<template>
  <transition v-if="isShow" name="download-popup">
    <div class="popup-back">
      <section class="popup pop-common-down">
        <h1 class="popup-title" tabindex="1">컨텐츠 다운로드 팝업</h1>
        <div class="popup-button-close">
          <a @click.prevent="close()" href="#">
            <img src="../../assets/images/common/btn-popup-close.svg" alt="팝업 닫기">
          </a>
        </div>
        <template v-if="downloadLink">
          <h2 tabindex="0">파일 다운로드</h2>
          <p tabindex="0">
            파일 다운로드 &gt; 마우스 오른쪽 버튼 클릭 &gt;<br>
            ‘다른 이름으로 대상저장’하시면 파일 다운로드가 시작됩니다.
          </p>
          <a :href="downloadLink" target="_blank" class="file-down" rel="noopener noreferrer">파일 다운로드</a>
        </template>
        <template v-else-if="!isAuthority">
          <h1 v-html="exitTitle"></h1>
          <p v-html="exitMessage"></p>
          <div class="btn-purple">
            <a v-if="exitButton === 'confirm'" @click.prevent="clickClose()" href="#">확인</a>
            <a v-else @click.prevent="clickVoucher()" href="#">구매하기</a>
          </div>
        </template>
        <template v-else>
          <h2 tabindex="0">다운로드 화질 선택</h2>
          <ul class="pop-down">
            <li v-for="(quality, index) in dataQualityList" class="radio-style" :key="index">
              <input type="radio" :id="quality.id" class="radio-purple" name="q-download" :value="quality.id" v-model="selected">
              <label :for="quality.id">{{ quality.name }}</label>
            </li>
          </ul>
          <div class="btn-purple">
            <a @click.prevent="clickDownload()" @keypress.enter="clickDownload()" href="#">확인</a>
          </div>
        </template>
      </section>
    </div>
  </transition>
</template>

<script>
  import { changeProfileProc } from '@/common/utils/login'
  import { getStreaming, postDownloads, getVodContentsDetail, getMovieContentsDetail } from '@/common/utils/request'
  import { getGUID, setEnterChange } from '@/common/utils/common'
  import { showVoucherPopup } from '@/common/utils/scalable.player'
  import _ from 'lodash'
  export default {
    props: {
      close: {
        type: Function
      },
      contenttype: {
        type: String
      },
      contentid: {
        type: String
      },
      contentInfo: {
        type: Object
      }
    },
    data () {
      return {
        selected: '480p',
        downloadLink: undefined,
        dataCheck: undefined,
        data: undefined,
        dataQualityList: undefined,
        isShow: false,
        isAuthority: false, // 다운로드 권한이 있는지
        isDownloadPopup: false,
        exitTitle: '',
        exitMessage: '',
        exitButton: '',
        isLoading: true
      }
    },
    methods: {
      clickVoucher () {
        showVoucherPopup({
          type: this.contenttype === 'movie' ? 'moviedownload' : 'voddownload',
          contentInfo: this.contentInfo
        })
        this.close()
      },
      // 다운로드 버튼 클릭
      clickDownload () {
        getStreaming({ contenttype: this.contenttype,
          contentid: encodeURIComponent(this.contentid),
          action: 'download',
          quality: this.selected,
          guid: getGUID(),
          authtype: 'url',
          lastplayid: 'none',
          isabr: 'n',
          ishevc: 'n' }).then((response) => {
          this.data = response.data
          if (response.data.play === 'y') {
            postDownloads({ contenttype: this.contenttype, id: this.contentid, quality: this.selected }).then(() => {
              this.downloadFile(response.data.playurl)
            })
          } else {
            this.exitTitle = response.data.preview.exittitle || '다운로드 안내'
            this.exitMessage = setEnterChange(_.get(response.data, ['preview', 'exitmsg'], '')) || '다운로드 권한이 없습니다. <br>다운로드가 포함된 이용권을 구매하시겠습니까?'
            this.exitButton = response.data.preview.exitbtn
            this.isAuthority = false
          }
        }).catch((error) => {
          if (error.response && error.response.status === 551 &&
            error.response.data.resultcode === '303') {
            this.changeProfileProc()
          }
        })
      },
      // 파일 다운로드 처리
      downloadFile (url) {
        this.downloadLink = url
      },
      changeProfileProc () {
        changeProfileProc({ profileId: 0 }).then(() => {
          window.location.reload()
        })
      },
      clickClose () {
        this.close()
      }
    },
    created () {
      // 최저 화질로 다운로드 권한이 있는지 체크
      // fixme: ♻️ contents detail 을 한번 더 호출 할 필요가 있나? movie/vod/live/break-list-download/thumb-all-vod 에사 사용 content id 를 props 로 넘겨 주고 있음. 수정이 필요 할 듯 (23-05-22)
      const contentsApi = this.contenttype === 'vod' ? getVodContentsDetail({ contentid: this.contentid }) : getMovieContentsDetail({ movieid: this.contentid })
      getStreaming({
        contenttype: this.contenttype,
        contentid: this.contentid,
        action: 'download',
        quality: '480p',
        guid: getGUID(),
        authtype: 'url',
        lastplayid: 'none',
        isabr: 'n',
        ishevc: 'n'
      }).then(({ data }) => {
        this.isShow = true
        contentsApi.then(({ data }) => {
          if (this.isAuthority) {
            this.dataQualityList = _.get(data, ['qualities', 'list'], []).filter(quality => quality.name !== '오디오모드')
            this.selected = this.dataQualityList.filter((quality) => quality.id === '480p').length !== 0 ? '480p' : _.get(this.dataQualityList, ['0', 'id'], '480p')
          }
        })
        this.isAuthority = data.play === 'y'
        if (!this.isAuthority) {
          this.exitTitle = data.preview.exittitle || '다운로드 안내'
          this.exitMessage = setEnterChange(_.get(data, ['preview', 'exitmsg'], '')) || '다운로드 권한이 없습니다. <br>다운로드가 포함된 이용권을 구매하시겠습니까?'
          this.exitButton = data.preview.exitbtn
        }
      }).catch((error) => {
        if (error.response && error.response.status === 551 &&
          error.response.data.resultcode === '303') {
          this.changeProfileProc()
        } else {
          this.close()
        }
      })
    }
  }
</script>
<style>
  .download-popup-enter-active, .download-popup-leave-active{
    transition: opacity .3s
  }

  .download-popup-enter, .download-popup-leave-to{ /* .fade-leave-active below version 2.1.8 */
    opacity: 0
  }
</style>
